export const INVENTORY = 'INVENTORY'
export const INVENTORY_PRODUCT_CREATE = 'INVENTORY_PRODUCT_CREATE'
export const INVENTORY_PRODUCT_UPDATE = 'INVENTORY_PRODUCT_UPDATE'
export const INVENTORY_PRODUCTS = 'INVENTORY_PRODUCTS'
export const INVENTORY_PRODUCTS_BULK_REMOVE = 'INVENTORY_PRODUCTS_BULK_REMOVE'
export const INVENTORY_PRODUCTS_REMOVE = 'INVENTORY_PRODUCTS_REMOVE'
export const INVENTORY_PRODUCT = 'INVENTORY_PRODUCT'
// Suppliers
export const INVENTORY_SUPPLIER_CREATE = 'INVENTORY_SUPPLIER_CREATE'
export const INVENTORY_SUPPLIER_UPDATE = 'INVENTORY_SUPPLIER_UPDATE'
export const INVENTORY_SUPPLIERS = 'INVENTORY_SUPPLIERS'
export const INVENTORY_SUPPLIERS_BULK_REMOVE = 'INVENTORY_SUPPLIERS_BULK_REMOVE'
export const INVENTORY_SUPPLIERS_REMOVE = 'INVENTORY_SUPPLIERS_REMOVE'
export const INVENTORY_SUPPLIER = 'INVENTORY_SUPPLIER'
// Product Categories
export const INVENTORY_PRODUCT_CATEGORY_CREATE = 'INVENTORY_PRODUCT_CATEGORY_CREATE'
export const INVENTORY_PRODUCT_CATEGORY_UPDATE = 'INVENTORY_PRODUCT_CATEGORY_UPDATE'
export const INVENTORY_PRODUCT_CATEGORIES = 'INVENTORY_PRODUCT_CATEGORIES'
export const INVENTORY_PRODUCT_CATEGORIES_BULK_REMOVE = 'INVENTORY_PRODUCT_CATEGORIES_BULK_REMOVE'
export const INVENTORY_PRODUCT_CATEGORIES_REMOVE = 'INVENTORY_PRODUCT_CATEGORIES_REMOVE'
export const INVENTORY_PRODUCT_CATEGORY = 'INVENTORY_PRODUCT_CATEGORY'
// Metric Types
export const INVENTORY_METRIC_TYPE_CREATE = 'INVENTORY_METRIC_TYPE_CREATE'
export const INVENTORY_METRIC_TYPE_UPDATE = 'INVENTORY_METRIC_TYPE_UPDATE'
export const INVENTORY_METRIC_TYPES = 'INVENTORY_METRIC_TYPES'
export const INVENTORY_METRIC_TYPES_BULK_REMOVE = 'INVENTORY_METRIC_TYPES_BULK_REMOVE'
export const INVENTORY_METRIC_TYPES_REMOVE = 'INVENTORY_METRIC_TYPES_REMOVE'
export const INVENTORY_METRIC_TYPE = 'INVENTORY_METRIC_TYPE'

export default {
    INVENTORY,
    INVENTORY_PRODUCT,
    INVENTORY_PRODUCT_CREATE,
    INVENTORY_PRODUCTS,
    INVENTORY_PRODUCTS_BULK_REMOVE,
    INVENTORY_PRODUCTS_REMOVE,
    INVENTORY_PRODUCT_UPDATE,
    INVENTORY_SUPPLIER_CREATE,
    INVENTORY_SUPPLIER_UPDATE,
    INVENTORY_SUPPLIERS,
    INVENTORY_SUPPLIERS_BULK_REMOVE,
    INVENTORY_SUPPLIERS_REMOVE,
    INVENTORY_SUPPLIER,
    INVENTORY_PRODUCT_CATEGORY_CREATE,
    INVENTORY_PRODUCT_CATEGORY_UPDATE,
    INVENTORY_PRODUCT_CATEGORIES,
    INVENTORY_PRODUCT_CATEGORIES_BULK_REMOVE,
    INVENTORY_PRODUCT_CATEGORIES_REMOVE,
    INVENTORY_PRODUCT_CATEGORY,
    INVENTORY_METRIC_TYPE_CREATE,
    INVENTORY_METRIC_TYPE_UPDATE,
    INVENTORY_METRIC_TYPES,
    INVENTORY_METRIC_TYPES_BULK_REMOVE,
    INVENTORY_METRIC_TYPES_REMOVE,
    INVENTORY_METRIC_TYPE
}
